import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";

const CITIES = [
  { city: "London", flag: "🇬🇧" },
  { city: "São Paulo", flag: "🇧🇷" },
  { city: "Mexico City", flag: "🇲🇽" },
  { city: "Lagos", flag: "🇳🇬" },
  { city: "Tokyo", flag: "🇯🇵" },
  { city: "Berlin", flag: "🇩🇪" },
  { city: "Paris", flag: "🇫🇷" },
  { city: "Buenos Aires", flag: "🇦🇷" },
  { city: "New York", flag: "🇺🇸" },
  { city: "Toronto", flag: "🇨🇦" },
  { city: "Madrid", flag: "🇪🇸" },
  { city: "Cairo", flag: "🇪🇬" },
  { city: "Seoul", flag: "🇰🇷" },
  { city: "Mumbai", flag: "🇮🇳" },
  { city: "Amsterdam", flag: "🇳🇱" },
  { city: "Istanbul", flag: "🇹🇷" },
  { city: "Johannesburg", flag: "🇿🇦" },
  { city: "Sydney", flag: "🇦🇺" },
  { city: "Lisbon", flag: "🇵🇹" },
  { city: "Casablanca", flag: "🇲🇦" },
  { city: "Bogotá", flag: "🇨🇴" },
  { city: "Nairobi", flag: "🇰🇪" },
  { city: "Dubai", flag: "🇦🇪" },
  { city: "Milan", flag: "🇮🇹" },
  { city: "Dakar", flag: "🇸🇳" },
  { city: "Chicago", flag: "🇺🇸" },
  { city: "Accra", flag: "🇬🇭" },
  { city: "Lima", flag: "🇵🇪" },
  { city: "Riyadh", flag: "🇸🇦" },
  { city: "Doha", flag: "🇶🇦" },
  { city: "Stockholm", flag: "🇸🇪" },
  { city: "Zagreb", flag: "🇭🇷" },
  { city: "Montevideo", flag: "🇺🇾" },
  { city: "Los Angeles", flag: "🇺🇸" },
  { city: "Osaka", flag: "🇯🇵" },
  { city: "Santiago", flag: "🇨🇱" },
  { city: "Jakarta", flag: "🇮🇩" },
];

const FIRST_NAMES = [
  "Alex", "Maria", "James", "Yuki", "Ahmed", "Sofia", "Lucas", "Fatima",
  "Carlos", "Emma", "Omar", "Priya", "Liam", "Aisha", "Diego", "Chen",
  "Marco", "Sarah", "Kofi", "Julia", "Mateo", "Nina", "David", "Amara",
  "Josh", "Léa", "Kwame", "Isabella", "Raj", "Chloe", "Tariq", "Anna",
];

function getRandomEntry() {
  const city = CITIES[Math.floor(Math.random() * CITIES.length)];
  const name = FIRST_NAMES[Math.floor(Math.random() * FIRST_NAMES.length)];
  const minutesAgo = Math.floor(Math.random() * 12) + 1;
  return { ...city, name, minutesAgo, id: Math.random() };
}

export function SocialProofToast() {
  const [current, setCurrent] = useState<ReturnType<typeof getRandomEntry> | null>(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    // Show first one after 3-6 seconds
    const initialDelay = 3000 + Math.random() * 3000;

    const showToast = () => {
      setCurrent(getRandomEntry());
      setVisible(true);

      // Hide after 3.5s
      setTimeout(() => setVisible(false), 3500);
    };

    const firstTimer = setTimeout(() => {
      showToast();
      // Then repeat every 6-12 seconds
      const interval = setInterval(showToast, 6000 + Math.random() * 6000);
      return () => clearInterval(interval);
    }, initialDelay);

    return () => clearTimeout(firstTimer);
  }, []);

  return (
    <div className="fixed bottom-20 sm:bottom-24 left-3 sm:left-6 z-[60] pointer-events-none">
      <AnimatePresence>
        {visible && current && (
          <motion.div
            key={current.id}
            initial={{ opacity: 0, y: 20, x: -10, scale: 0.9 }}
            animate={{ opacity: 1, y: 0, x: 0, scale: 1 }}
            exit={{ opacity: 0, y: -10, scale: 0.95 }}
            transition={{ type: "tween", ease: [0.2, 0.8, 0.2, 1], duration: 0.4 }}
            className="bg-card/95 backdrop-blur-xl border border-border rounded-xl shadow-xl px-4 py-3 flex items-center gap-3 max-w-[280px] sm:max-w-xs pointer-events-auto"
          >
            <span className="text-2xl shrink-0">{current.flag}</span>
            <div className="min-w-0">
              <p className="font-body text-sm text-foreground font-semibold truncate">
                {current.name} created a bracket
              </p>
              <p className="font-body text-xs text-muted-foreground">
                {current.city} · {current.minutesAgo}m ago
              </p>
            </div>
            <div className="w-2 h-2 rounded-full bg-green-500 animate-pulse shrink-0" />
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
}
